class StickyATC extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const mobileShowAfter = 2100;
    const tabletShowAfter = 1000;
    const desktopShowAfter = 600;

    this.sticky = this.querySelector(".sticky-atc");
    this.isArticleBar = this.dataset.article === "true";

    const articleAuthor = document.querySelector(".article-author");
    // Hide while the footer is on screen so the bar never covers its legal copy.
    const blockers = document.querySelectorAll("[data-floating-enter-cta-blocker]");

    const getShowAfter = () => {
      const width = window.visualViewport?.width || window.innerWidth;
      if (width < 640) return mobileShowAfter;
      if (width < 1024) return tabletShowAfter;
      return desktopShowAfter;
    };

    const getScrollY = () =>
      window.scrollY ??
      window.pageYOffset ??
      document.documentElement?.scrollTop ??
      document.body?.scrollTop ??
      0;

    const getViewportHeight = () =>
      window.visualViewport?.height || window.innerHeight;

    const getMaxScrollY = () => {
      const doc = document.documentElement;
      if (!doc) return 0;
      return Math.max(0, doc.scrollHeight - getViewportHeight());
    };

    const onScroll = () => {
      const desiredShowAfter = getShowAfter();
      const maxScrollY = getMaxScrollY();
      const showAfter = Math.min(desiredShowAfter, Math.max(0, maxScrollY - 1));
      const scrollY = getScrollY();

      const shouldShow = scrollY > showAfter;
      let shouldHide = false;

      if (articleAuthor) {
        const authorBottom =
          articleAuthor.getBoundingClientRect().bottom + getScrollY();
        shouldHide = scrollY + getViewportHeight() > authorBottom;
      }

      for (const blocker of blockers) {
        if (blocker.getBoundingClientRect().top < getViewportHeight()) {
          shouldHide = true;
        }
      }

      if (shouldShow && !shouldHide) {
        this.sticky.classList.add("active");
      } else {
        this.sticky.classList.remove("active");
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    onScroll();
  }
}

customElements.define("sticky-atc", StickyATC);
